'use client';

import * as React from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { makeQueryClient } from '@/services/query/query-client';

/**
 * Owns the react-query client. One instance per browser session (kept in a
 * ref so Fast Refresh / re-renders never recreate the cache).
 */
export function QueryProvider({ children }: { children: React.ReactNode }) {
  const clientRef = React.useRef<ReturnType<typeof makeQueryClient>>();
  if (!clientRef.current) clientRef.current = makeQueryClient();

  return <QueryClientProvider client={clientRef.current}>{children}</QueryClientProvider>;
}
